import options from './chart-co2-only.component';

export default {
    selector: 'dtChartCo2Only',
    options
};
